import React from 'react';

import { envConfig } from 'config/env-config';
import { selectIsAuthed } from 'store/customer';
import { useAppSelector } from 'store/store';

import { AP_FOOTER_TEST_ID } from './Footer.test-ids';

const Footer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  const isAuthed = useAppSelector(selectIsAuthed);
  return (
    <ap-footer-wc
      envurl={envConfig.url}
      authenticated={isAuthed}
      data-testid={AP_FOOTER_TEST_ID}
      {...props}
    ></ap-footer-wc>
  );
};

export default Footer;
